import { useForm, Controller, FormProvider } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Button, Form, Col, Row } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import "react-tabs/style/react-tabs.css";
import moment from "moment-timezone";

import { allSharedComponents } from "../../../../../shared";
import {
  isPhoneValid,
  unloadWidget,
  getLocalStorageItem,
  getCurrentUserRole,
  getDocumentStatusName,
  getUserPayload,
  serverFormatToDateObject,
  mergeDateTimeToServerFormat,
  serverFormatToDateString,
  UTCWithTimezoneToISOString,
  appendMandatorySignAndTimezoneText,
  calculateVAT,
  precisionCalculation,
} from "../../../../../system";
import {
  profileActions,
  instructorActions,
  paymentActions,
  UserActions,
  SubscriptionActions,
  authActions,
} from "../../../../../redux/actions";
import {
  emptyString,
  countryConstants,
  documentTypeConstants,
  translationConstants,
  roles,
  UserVerificationApprovalStatus,
  fieldLengthConstants,
  Directions,
  getNameById,
  StorageKeys,
  paymentType,
  preferedLanguagesContants,
  freelanceStatusEnum,
  initialGridStateForParams,
  subscriptionTypeConstants,
  timezoneConstants,
  bloodTypes,
  sidebarCertificatesTabIndex,
  calculationOperations,
} from "../../../../../constants";
import {
  AddProfileImage,
  TableViewIcon,
} from "../../../../../assets/images/icon/iconsProvider";
import {
  EditIcon,
  RatingStarIcon,
  BreakdownIcon,
  ProfilePlaceholder,
} from "../../../../../assets/images/icon";

import GeneralTabSideView from "../Components/GeneralTabSideView";

const {
  CustomModal,
  BaseUpdateUserDocuments,
  BecomeVerifiedUser,
  BecomeMemberModal,
  BaseForm,
  ReactDatePickerWrapper,
  ReviewStars,
  PricingModal,
} = allSharedComponents;

const GeneralTab = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const userPayload = getUserPayload();
  const role = getCurrentUserRole();

  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [isPriceBreakdownModal, setPriceBreakdownModal] = useState(null);
  const [formData, setFormData] = useState(null);
  const [isMemberModal, setMemeberModal] = useState(null);
  const [urlCheckoutId, setUrlCheckoutId] = useState(
    new URLSearchParams(location?.search)?.get("id")
  );
  const [userPaymentType, setUserPaymentType] = useState(
    new URLSearchParams(location?.search)?.get("freelancer")
  );
  const [saveCardCheck, setSaveCardCheck] = useState(
    new URLSearchParams(location?.search)?.get("saveCard")
  );
  const [selectedIndex, setSelectedIndex] = useState(
    sidebarCertificatesTabIndex.Sailor
  );

  const countries = useSelector((state) => state.LoginReducer.countries);
  const cities = useSelector((state) => state.LoginReducer.cities);
  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  let profileImageUrl = useSelector(
    (state) => state.ProfileReducer.profileImgUrl
  );
  const modalOpen = useSelector(
    (state) => state.InstructorReducer.isViewModalOpen
  );
  const isSailorProfile = useSelector(
    (state) => state.systemReducer.isSailorProfile
  );
  const userData = useSelector((x) => x.LoginReducer.UserData.user);
  const profileData = useSelector((state) => state.ProfileReducer.profileData);

  const userInfo = profileData?.userInfo;
  // CHECK ARABIC NAME EXITS OR NOT
  let arabicName =
    (userInfo?.arabicFirstName ? userInfo?.arabicFirstName : "") +
    " " +
    (userInfo?.arabicLastName ? userInfo?.arabicLastName : "");
  // CHECK BOTH FIRST OR LAST NAME EXISTS OR NOT
  let englishName =
    (userInfo?.englishFirstName ? userInfo?.englishFirstName : "") +
    " " +
    (userInfo?.englishLastName ? userInfo?.englishLastName : "");

  const methods = useForm();
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const {
    setValue,
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
  } = methods;

  const onSubmit = (data) => {
    const { dob, ...updatedFormData } = formData;
    dispatch(
      profileActions.updateProfileData({
        ...updatedFormData,
        dobString: mergeDateTimeToServerFormat(
          formData.dob,
          moment().set(timezoneConstants.twelveAM).toDate()
        ),
        cityId: !!isResidenceSaudi() ? formData?.cityId : null,
      })
    );
  };
  const UserRole = getLocalStorageItem(StorageKeys.activeRole);

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      dispatch(profileActions.setProfilePicPreview(e.target.result));
    };

    reader.readAsDataURL(file[0]);
    const formData = new FormData();
    formData.append("SystemUserId", systemUserId);
    formData.append("DocumentTypeId", documentTypeConstants.PROFILE_PICTURE);
    formData.append("CenterId", "");
    formData.append("File", file[0]);
    dispatch(profileActions.uploadProfilePic(formData, systemUserId));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleFileUpload,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
    },
    multiple: true,
  });

  useEffect(() => {
    dispatch(authActions.fetchCountries());
    dispatch(profileActions.getProfileImageUrl(systemUserId));
    dispatch(profileActions.getProfileData(systemUserId));
    dispatch(authActions.fetchCities(countryConstants.SAUDIA_ARABIA));
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userPayload?.user?.role === roles.FreelanceInstructor) {
      dispatch(
        instructorActions.getFreelancerSportsDetail(userPayload?.instructorId)
      );
    }
    if (userPayload?.instructorCenterId) {
      dispatch(
        instructorActions.getInstructorCenterDetail(userPayload?.instructorId)
      );
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Set initial form values from userInfo
    setValue("firstName", userInfo?.englishFirstName);
    setValue("lastName", userInfo?.englishLastName);
    setValue("firstNameArabic", userInfo?.arabicFirstName);
    setValue("lastNameArabic", userInfo?.arabicLastName);
    setValue("email", userInfo?.email);
    setValue("phoneNumber", userInfo?.phoneNumber);
    setValue("gender", userInfo?.gender);
    setValue("address", userInfo?.address);
    setValue("nationality", userInfo?.nationality);
    setValue("countryresidence", userInfo?.countryId);
    setValue("cityresidence", userInfo?.cityId);
    setValue("preferredLangauge", userInfo?.preferredLangauge);
    setValue("bloodGroup", userInfo?.bloodGroup);
    if (userInfo?.dobString) {
      setValue("dateOfBirth", serverFormatToDateObject(userInfo?.dobString), {
        shouldValidate: true,
      });
    }
    // eslint-disable-next-line
  }, [userInfo]);

  useEffect(() => {
    if (profileData.userInfo) {
      setFormData({
        ...profileData.userInfo,
        dob: serverFormatToDateObject(profileData.userInfo.dobString),
      });
    }
    // eslint-disable-next-line
  }, [profileData]);

  const onSetShow = () => {
    dispatch(instructorActions.toggleViewModal(false));
  };

  const membershipModal = () => {
    unloadWidget();
    setMemeberModal((prev) => !prev);
    dispatch(paymentActions.paymentCheckoutNull());
  };

  const freelancePaymentOnSuccess = () => {
    dispatch(
      authActions.setIsFreelancerStatusInLoginReducer(roles.FreelanceInstructor)
    );
    dispatch(
      paymentActions.paymentHistoryFreelancer({
        systemUserId: userPayload?.user?.id,
        paymentType: paymentType.Freelance,
        params: initialGridStateForParams,
      })
    );
    dispatch(profileActions.getProfileData(systemUserId));
    dispatch(paymentActions.paymentCheckoutNull());
    dispatch(
      authActions.getNewUserPayload(() => {
        window.location.reload();
      })
    );
  };

  useEffect(() => {
    if (urlCheckoutId) {
      navigate(location.pathname);
      setUrlCheckoutId(null);
      if (userPaymentType) {
        let checkoutJSon = JSON.parse(
          localStorage.getItem("freelanceCheckoutDetail")
        );
        if (checkoutJSon) {
          checkoutJSon.checkoutId = urlCheckoutId;
          if (
            userPayload?.freelanceStatus ===
              freelanceStatusEnum.PaymentRejected ||
            userPayload?.freelanceStatus === freelanceStatusEnum.Restricted
          ) {
            dispatch(
              instructorActions.becomeFreelanceRePayment(
                checkoutJSon,
                freelancePaymentOnSuccess
              )
            );
          } else {
            dispatch(
              instructorActions.becomeFreelancePayment(
                checkoutJSon,
                freelancePaymentOnSuccess
              )
            );
          }
        }
      } else if (saveCardCheck) {
        dispatch(
          paymentActions.saveCard(urlCheckoutId, {
            systemUserId: userPayload?.user?.id,
          })
        );
      } else {
        dispatch(
          UserActions.becomeMember({ checkoutId: urlCheckoutId }, () => {
            dispatch(authActions.setIsMemberStatusInLoginReducer(true));
            dispatch(
              paymentActions.paymentHistory({
                systemUserId: userPayload?.user?.id,
                paymentType: paymentType.Membership,
                params: initialGridStateForParams,
              })
            );
            dispatch(profileActions.getProfileData(systemUserId));
            dispatch(paymentActions.paymentCheckoutNull());
          })
        );
      }
      setUserPaymentType(null);
      setSaveCardCheck(null);
    }
    // eslint-disable-next-line
  }, [urlCheckoutId]);

  useEffect(() => {
    const vat = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );
    const memebershipFee = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.MEMEBER_SHIP
    );
    const vatValue = calculateVAT(vat?.price, memebershipFee?.price);
    setPriceBreakdown({
      subTotal: memebershipFee?.price,
      vat: vat?.price,
      vatValue: vatValue,
      totalFees: precisionCalculation(
        vatValue,
        memebershipFee?.price,
        calculationOperations.addition
      ),
    });
    //eslint-disable-next-line
  }, [subscriptionPrices]);

  useEffect(() => {
    if (
      !isSailorProfile &&
      profileData?.instructorDigitalCertificates?.length > 0
    ) {
      setSelectedIndex(sidebarCertificatesTabIndex.Instructor); // Assuming Instructor tab is the second tab
    } else {
      setSelectedIndex(sidebarCertificatesTabIndex.Sailor);
    }
    //eslint-disable-next-line
  }, [isSailorProfile, profileData]);

  const isResidenceSaudi = () => {
    return (
      Number(formData?.countryId) === Number(countryConstants.SAUDIA_ARABIA)
    );
  };
  return (
    <>
      <div className="row w-100">
        <div className="col-md-8">
          <FormProvider {...methods}>
            <Form
              noValidate
              className={props.generalClassName}
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="mt-3 p-2 profile-img">
                  <img
                    alt="avatar"
                    className="avatar"
                    src={
                      profileImageUrl !== null
                        ? profileImageUrl
                        : ProfilePlaceholder
                    }
                  />
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <AddProfileImage className={"plus-icon-con upload-icon"} />
                  </div>
                </div>
                {(UserRole === roles.FreelanceInstructor ||
                  UserRole === roles.Instructor) && (
                  <div className="d-flex flex-column justify-content-end gap-2 mx-4">
                    <div>
                      <ReviewStars
                        value={userInfo?.instructorRating}
                        size={20}
                      />{" "}
                    </div>
                    <span className="font-14 text-end">
                      {t(translationConstants.OUT_OF)}{" "}
                      {userInfo?.noOfReviews ?? 0}{" "}
                      {t(translationConstants.REVIEWS)}
                    </span>
                  </div>
                )}
              </div>
              <Row>
                <Col>
                  <label className="Form-labels m-l-15 m-r-15 mt-1">
                    {direction === Directions.rtl
                      ? arabicName.trim().length == 0
                        ? englishName
                        : arabicName
                      : englishName}
                    {userInfo?.isMembershipHolder ? (
                      <img
                        alt="img-star"
                        src={RatingStarIcon}
                        className="m-l-14"
                      />
                    ) : (
                      ""
                    )}
                  </label>
                </Col>
                {userInfo?.isMembershipHolder === false &&
                  userInfo?.role !== roles.GeneralUser && (
                    <Col className="d-flex justify-content-end profile-button-margins">
                      <Button
                        className="profile-button m-0"
                        onClick={() => {
                          setMemeberModal(true);
                        }}
                      >
                        {t(translationConstants.BECOME_A_MEMBER)}
                      </Button>
                      <span className="info-icon">
                        <img
                          alt="img-info"
                          src={BreakdownIcon}
                          onClick={() => setPriceBreakdownModal(true)}
                        />
                      </span>
                    </Col>
                  )}
              </Row>
              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.firstName)}:
                  </Form.Label>
                  <Form.Control
                    {...register("firstName", {
                      required: t(translationConstants.firstNameRequired),
                      pattern: {
                        value: /^[A-Za-z\s]+$/i,
                        message: t(translationConstants.invalidFirstName),
                      },
                    })}
                    value={formData?.englishFirstName || emptyString}
                    onChange={(e) => {
                      setValue("firstName", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("firstName");
                      setFormData({
                        ...formData,
                        englishFirstName: e.target.value,
                      });
                    }}
                    id="firstName"
                    type="text"
                    placeholder={t(translationConstants.enterFirstName)}
                    maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  />
                  {errors.firstName && (
                    <p className="errorText">{errors.firstName.message}</p>
                  )}
                </Form.Group>

                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.lastName)}:
                  </Form.Label>
                  <Form.Control
                    {...register("lastName", {
                      required: t(translationConstants.lastNameRequired),
                      pattern: {
                        value: /^[A-Za-z\s]+$/i,
                        message: t(translationConstants.invalidLastName),
                      },
                    })}
                    onChange={(e) => {
                      setValue("lastName", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("lastName");
                      setFormData({
                        ...formData,
                        englishLastName: e.target.value,
                      });
                    }}
                    value={formData?.englishLastName || emptyString}
                    id="lastName"
                    type="text"
                    placeholder={t(translationConstants.enterLastName)}
                    maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  />
                  {errors.lastName && (
                    <p className="errorText">{errors.lastName.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.firstNameArabic)}:{" "}
                    <span>{t(translationConstants.optional)}</span>{" "}
                  </Form.Label>
                  <Form.Control
                    {...register("firstNameArabic", {
                      // ... your existing rules
                    })}
                    onChange={(e) => {
                      setValue("firstNameArabic", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("firstNameArabic");
                      setFormData({
                        ...formData,
                        arabicFirstName: e.target.value,
                      });
                    }}
                    id="firstNameArabic"
                    type="text"
                    value={formData?.arabicFirstName || emptyString}
                    placeholder="محمد"
                    style={{ direction: Directions.rtl }}
                    maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  />
                  {errors.firstNameArabic && (
                    <p className="errorText">
                      {errors.firstNameArabic.message}
                    </p>
                  )}
                </Form.Group>

                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.lastNameArabic)}:{" "}
                    <span>{t(translationConstants.optional)}</span>
                  </Form.Label>
                  <Form.Control
                    {...register("lastNameArabic", {})}
                    onChange={(e) => {
                      setValue("lastNameArabic", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("lastNameArabic");
                      setFormData({
                        ...formData,
                        arabicLastName: e.target.value,
                      });
                    }}
                    id="lastNameArabic"
                    type="text"
                    placeholder="احمد"
                    value={formData?.arabicLastName || emptyString}
                    style={{ direction: Directions.rtl }}
                    maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  />
                  {errors.lastNameArabic && (
                    <p className="errorText">{errors.lastNameArabic.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.email)}:
                  </Form.Label>
                  <Form.Control
                    {...register("email", {
                      required: t(translationConstants.emailRequired),
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
                        message: t(translationConstants.invalidEmail),
                      },
                    })}
                    onChange={(e) => {
                      setValue("email", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("email");
                      setFormData({
                        ...formData,
                        email: e.target.value,
                      });
                    }}
                    value={formData?.email || emptyString}
                    id="email"
                    type="email"
                    maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
                    placeholder="Ex: abc@example.com"
                  />
                  {errors.email && (
                    <p className="errorText">{errors.email.message}</p>
                  )}
                </Form.Group>
                <Form.Group className="form-phone-group">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.phoneNumber)}:
                  </Form.Label>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    rules={{
                      required: t(translationConstants.phoneNumberRequired),
                      validate: (value) => {
                        const isValid = isPhoneValid(value);
                        if (!isValid) {
                          return t(translationConstants.enterValidPhoneNumber);
                        }
                        return true;
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <PhoneInput
                        id="phone-number-registration"
                        defaultCountry="sa"
                        value={formData?.phoneNumber || emptyString}
                        onChange={(e) => {
                          setValue("phoneNumber", e, {
                            shouldValidate: true,
                          });
                          trigger("phoneNumber");
                          setFormData({
                            ...formData,
                            phoneNumber: e,
                          });
                        }}
                        maxLength={
                          fieldLengthConstants.PHONENUMBER_FIELD_LENGTH
                        }
                      />
                    )}
                  />
                  {errors.phoneNumber && (
                    <p className="errorText">{errors.phoneNumber.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {appendMandatorySignAndTimezoneText(
                      t(translationConstants.dateOfBirth),
                      t,
                      false
                    )}
                  </Form.Label>
                  <Controller
                    name="dateOfBirth"
                    control={control}
                    rules={{
                      required: t(translationConstants.dateOfBirthRequired),
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(date) => {
                          setValue(
                            "dateOfBirth",
                            serverFormatToDateObject(date),
                            {
                              shouldValidate: true,
                            }
                          );
                          trigger("dateOfBirth");
                          setFormData({
                            ...formData,
                            dob: date,
                          });
                          field.onChange(date);
                        }}
                        maxDate={new Date(UTCWithTimezoneToISOString())}
                        selected={formData?.dob}
                        value={formData?.dob || emptyString}
                      />
                    )}
                  />
                  {errors.dateOfBirth && (
                    <p className="errorText">{errors.dateOfBirth.message}</p>
                  )}
                </Form.Group>

                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.gender)}:
                  </Form.Label>
                  <Form.Select
                    className="custom-select-icon"
                    {...register("gender", {
                      required: t(translationConstants.genderSelectionRequired),
                    })}
                    aria-label="Default select example"
                    value={formData?.gender}
                    onChange={(e) => {
                      setValue("gender", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("gender");
                      setFormData({
                        ...formData,
                        gender: e.target.value,
                      });
                    }}
                  >
                    <option value="">
                      {t(translationConstants.selectGender)}
                    </option>
                    <option value={0}>{t(translationConstants.male)}</option>
                    <option value={1}>{t(translationConstants.female)}</option>
                  </Form.Select>
                  {errors.gender && (
                    <p className="errorText">{errors.gender.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.ADDRESS)}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    id="address"
                    value={formData?.address || emptyString}
                    placeholder={t(translationConstants.ENTER_ADDRESS)}
                    {...register("address", {
                      required: userInfo?.address
                        ? t(translationConstants.ADDRESS_REQUIRED)
                        : false,
                    })}
                    onChange={(e) => {
                      setValue("address", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("address");
                      setFormData({
                        ...formData,
                        address: e.target.value,
                      });
                    }}
                  />
                  {errors?.address && (
                    <p className="errorText">{errors?.address.message}</p>
                  )}
                </Form.Group>

                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.nationality)}:
                  </Form.Label>
                  <Form.Select
                    className="custom-select-icon"
                    {...register("nationality", {
                      required: t(translationConstants.nationalityRequired),
                    })}
                    aria-label="Default select example"
                    value={formData?.nationality}
                    onChange={(e) => {
                      setValue("nationality", e.target.value, {
                        shouldValidate: true,
                      });
                      trigger("nationality");
                      setFormData({
                        ...formData,
                        nationality: e.target.value,
                      });
                    }}
                  >
                    <option value="">
                      {t(translationConstants.selectnationality)}
                    </option>
                    {countries?.data?.map((data) => (
                      <option key={data.id} value={data.nationality}>
                        {direction === Directions.rtl
                          ? data.arabicNationality
                          : data.nationality}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.nationality && (
                    <p className="errorText">{errors.nationality.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="inputRow">
                <Form.Group className="form-group-register">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.countryOfResidence)}:
                  </Form.Label>
                  <Form.Select
                    className="custom-select-icon"
                    {...register("countryresidence", {
                      required: t(
                        translationConstants.countryResidenceRequired
                      ),
                    })}
                    onChange={(e) => {
                      const value = e.target.value;
                      setValue("countryresidence", value, {
                        shouldValidate: true,
                      });
                      value && dispatch(authActions.fetchCities(value));
                      trigger("countryresidence"); // Trigger validation for the 'countryresidence' field
                      e.stopPropagation();
                      setFormData({
                        ...formData,
                        countryId: e.target.value,
                      });
                    }}
                    value={formData?.countryId}
                    aria-label="Default select example"
                  >
                    <option value="">
                      {t(translationConstants.selectresidence)}
                    </option>
                    {countries?.data?.map((residence) => (
                      <option key={residence.id} value={residence.id}>
                        {direction === Directions.rtl
                          ? residence.arabicName
                          : residence.name}
                      </option>
                    ))}
                  </Form.Select>

                  {errors.countryresidence && (
                    <p className="errorText">
                      {errors.countryresidence.message}
                    </p>
                  )}
                </Form.Group>

                {!!isResidenceSaudi() && (
                  <Form.Group className="form-group-register">
                    <Form.Label
                      htmlFor="cityResidenceSelect"
                      className="Form-labels"
                    >
                      {t(translationConstants.cityofresidence)}:
                    </Form.Label>
                    <Form.Select
                      id="cityResidenceSelect"
                      {...register("cityresidence", {
                        required: {
                          value: true,
                          message: t(
                            translationConstants.cityResidenceRequired
                          ),
                        },
                      })}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("cityresidence", value, {
                          shouldValidate: true,
                        });
                        trigger("cityresidence"); // Trigger validation for the 'countryresidence' field
                        e.stopPropagation();
                        setFormData({
                          ...formData,
                          cityId: !!isResidenceSaudi()
                            ? Number(e.target.value)
                            : null,
                        });
                      }}
                      aria-label="Default select example"
                      value={formData?.cityId}
                    >
                      <option value="">
                        {t(translationConstants.selectcity)}
                      </option>
                      {cities?.map((city) => (
                        <option key={city.id} value={city.id}>
                          {direction === Directions.rtl
                            ? city.arabicName
                            : city.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.cityresidence && (
                      <p className="errorText">
                        {errors.cityresidence.message}
                      </p>
                    )}
                  </Form.Group>
                )}

                <Form.Group
                  className={`form-group-register ${
                    Number(formData?.countryId) ===
                    Number(countryConstants.SAUDIA_ARABIA)
                      ? "mt-3"
                      : ""
                  }`}
                >
                  <Form.Label
                    htmlFor="preferredLanguageSelect"
                    className="Form-labels"
                  >
                    {t(translationConstants.PREFERRED_LANGUAGE)}:
                  </Form.Label>
                  <Form.Select
                    id="preferredLanguageSelect"
                    {...register("preferredLangauge", {
                      required: t(
                        translationConstants.SELECT_PREFERRED_LANGUAGE_Required
                      ),
                    })}
                    value={formData?.preferredLangauge}
                    onChange={(e) => {
                      const value = e.target.value;
                      setValue("preferredLangauge", value, {
                        shouldValidate: true,
                      });
                      trigger("preferredLangauge"); // Trigger validation for the 'countryresidence' field
                      e.stopPropagation();
                      setFormData({
                        ...formData,
                        preferredLangauge: e.target.value,
                      });
                    }}
                    aria-label="Default select example"
                  >
                    <option value="">
                      {t(translationConstants.SELECT_PREFERRED_LANGUAGE)}
                    </option>
                    <option value="0">
                      {preferedLanguagesContants.Arabic}
                    </option>
                    <option value="1">
                      {preferedLanguagesContants.English}
                    </option>
                  </Form.Select>
                  {errors.preferredLangauge && (
                    <p className="errorText">
                      {errors.preferredLangauge.message}
                    </p>
                  )}
                </Form.Group>

                <Form.Group className="form-group-register mt-3">
                  <Form.Label className="Form-labels">
                    {t(translationConstants.BLOOD_GROUP)}:
                  </Form.Label>
                  <Form.Select
                    className="custom-select-icon"
                    {...register("bloodGroup", {
                      required: t(translationConstants.BLOOD_GROUP_REQUIRED),
                    })}
                    value={formData?.bloodGroup}
                    onChange={(e) => {
                      const value = e.target.value;
                      setValue("bloodGroup", value, {
                        shouldValidate: true,
                      });
                      trigger("bloodGroup"); // Trigger validation for the 'countryresidence' field
                      e.stopPropagation();
                      setFormData({
                        ...formData,
                        bloodGroup: e.target.value,
                      });
                    }}
                  >
                    <option value="">
                      {t(translationConstants.SELECT_BLOOD_GROUP)}
                    </option>
                    {Object.values(bloodTypes).map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.bloodGroup && (
                    <p className="errorText">{errors.bloodGroup.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="d-flex justify-content-end profile-button-margins">
                <Button className="profile-button" type="submit">
                  {t(translationConstants.UPDATE_PROFILE)}
                </Button>
              </div>
            </Form>
          </FormProvider>
        </div>
        <div className="col-md-4 border-vr">
          <div className="user-profile">
            {role !== roles.GeneralUser ? (
              <Tabs
                selectedIndex={selectedIndex}
                onSelect={(index) => setSelectedIndex(index)}
              >
                <TabList>
                  {profileData?.practitionerDigitalCertificates?.length > 0 ? (
                    <Tab>{t(translationConstants.PRACTITIONER)}</Tab>
                  ) : (
                    ""
                  )}

                  {profileData?.instructorDigitalCertificates?.length > 0 &&
                  profileData?.instructorStatus !==
                    UserVerificationApprovalStatus.Disabled ? (
                    <Tab>{t(translationConstants.INSTRUCTOR)}</Tab>
                  ) : (
                    ""
                  )}
                </TabList>
                {profileData?.practitionerDigitalCertificates?.length > 0 ? (
                  <TabPanel className="">
                    <GeneralTabSideView
                      certificates={
                        profileData?.practitionerDigitalCertificates
                      }
                    />
                  </TabPanel>
                ) : (
                  ""
                )}
                {profileData?.instructorDigitalCertificates?.length > 0 ? (
                  <TabPanel className="">
                    <GeneralTabSideView
                      certificates={profileData?.instructorDigitalCertificates}
                      isInstructorTab={true}
                    />
                  </TabPanel>
                ) : (
                  ""
                )}
                {profileData?.documents?.length > 0 && (
                  <>
                    <p className="border-top mb-3" />
                    <div className="m-l-15 m-r-15 px-2">
                      <h6 className="verify-doc w-100 d-flex justify-content-between align-items-center">
                        <Col>
                          <h6 className="font-14 fw-700 text-decoration-underline m-0">
                            {t(translationConstants.VERIFICATION_DOCUMENTS)}{" "}
                          </h6>
                        </Col>
                        <Col className="d-flex justify-content-center">
                          <div className="pill-width">
                            <span className="font-12 px-2">
                              {t(translationConstants.Update)}
                            </span>
                            <img
                              className="cursor-pointer"
                              src={EditIcon}
                              alt="editIcon"
                              onClick={() => {
                                dispatch(
                                  instructorActions.toggleViewModal(true)
                                );
                              }}
                            />
                          </div>
                        </Col>
                      </h6>
                      {Object.entries(
                        profileData?.documents.reduce((acc, document) => {
                          document?.files?.forEach((file) => {
                            const key = `${file?.documentNumber}-${file?.expiredOn}-${file?.documentStatus}}`;
                            if (!acc[key]) {
                              acc[key] = {
                                documentType: document.documentTypeId,
                                files: [],
                              };
                            }
                            acc[key].files.push(file);
                          });
                          return acc;
                        }, {})
                      ).map(([key, group], index) => (
                        <div key={index} className="pb-3">
                          {group.files.map((file, fileIndex) => (
                            <div className="row w-100 py-1" key={fileIndex}>
                              <Col className="">
                                <p>{t(getNameById(group.documentType))}</p>
                              </Col>
                              <Col className="d-flex justify-content-center">
                                <div className="pill-width">
                                  <a
                                    href={file.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="cursor-pointer align-middle"
                                  >
                                    <TableViewIcon />
                                  </a>
                                </div>
                              </Col>
                            </div>
                          ))}
                          <div className="row py-2">
                            <div className="row">
                              <Col>
                                <p className="fw-700">
                                  {appendMandatorySignAndTimezoneText(
                                    t(translationConstants.expiryData),
                                    t,
                                    false,
                                    "font-13"
                                  )}
                                </p>
                              </Col>
                              <Col className="d-flex justify-content-center">
                                <p>
                                  {serverFormatToDateString(
                                    group.files[0].expiredOnString,
                                    timezoneConstants.dayMonthYearFormat
                                  )}
                                </p>
                              </Col>
                            </div>
                            <div className="row">
                              <Col>
                                <p className="fw-700">
                                  {t(translationConstants.STATUS)}:
                                </p>
                              </Col>
                              <Col className="d-flex justify-content-center">
                                <p className="capitalize-first pill-width">
                                  {t(
                                    getDocumentStatusName(
                                      group.files[0].documentStatus
                                    )
                                  )}
                                </p>
                              </Col>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </Tabs>
            ) : (
              ""
            )}
          </div>
        </div>

        <CustomModal
          size="sm"
          scrollable={true}
          show={isMemberModal}
          setShow={membershipModal}
        >
          <BaseForm customClass="payment-modal-min-height">
            <BecomeMemberModal
              title={t(translationConstants.BECOME_A_MEMBER)}
              membershipModal={membershipModal}
              setPriceBreakdownModal={setPriceBreakdownModal}
            />
          </BaseForm>
        </CustomModal>

        {modalOpen && (
          <CustomModal
            scrollable
            show={modalOpen}
            setShow={onSetShow}
            size="md"
          >
            <BaseUpdateUserDocuments>
              <span className="becomeverifiedPara">
                {t(translationConstants.UPDATE_VERIFIED_DOCUMENT)}
                <hr />
              </span>
              <BecomeVerifiedUser
                isBecomeVerifiedUser
                dobString={userData?.dobString}
                countryId={userData.nationality}
              />
              <Button className="SubmitDocs-button" type="submit">
                {t(translationConstants.submit)}
              </Button>
            </BaseUpdateUserDocuments>
          </CustomModal>
        )}

        <CustomModal
          size={"sm"}
          scrollable
          show={isPriceBreakdownModal}
          setShow={setPriceBreakdownModal}
          closeBtnClasses={"login-modal-close-btn"}
          customClass={"freelance-instructor-model-sm"}
          closeOnOutsideClick={true}
        >
          <PricingModal data={priceBreakdown} isMembership={true} />
        </CustomModal>
      </div>
    </>
  );
};

export default GeneralTab;
